<template>
  <div class="initialMessage" :class="{active: messageOpen}">
    <div class="initialMessageInner">
      <div class="iniLogo"><img alt="" :src="require('@/assets/extras/logo.svg')"></div>
      <div class="iniTitle">Legal &amp; General is building an inclusive society</div>
      <div class="iniDescr">Legal &amp; General is reshaping Britain's towns and cities.
      From the delivery of diversified homes, to the regeneration of cities across the UK,
      we use our long term investments to build better futures. <br/>
      Explore to find out more about our unique approach….</div>
      <div class="closeMessage" @click="closeMessage">Explore the map</div>
      <div class="initIllustration">
        <div class="initIllustrationInner">
          <div class="helixPole1 helixPole">
            <img :src="require('@/assets/extras/helix.svg')" class="helix1">
            <img :src="require('@/assets/extras/pole.svg')" class="pole1 pole">
          </div>
          <div class="helixPole2 helixPole">
            <img :src="require('@/assets/extras/helix.svg')" class="helix2">
            <img :src="require('@/assets/extras/pole.svg')" class="pole2 pole">
          </div>
          <div class="helixPole3 helixPole">
            <img :src="require('@/assets/extras/helix.svg')" class="helix3">
            <img :src="require('@/assets/extras/pole.svg')" class="pole3 pole">
          </div>
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud1">
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud2">
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud3">
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud4">
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud1-2">
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud2-2">
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud3-2">
          <img :src="require('@/assets/extras/cloud.svg')" class="cloud4-2">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InitialMessage',
  data() {
    return {
      messageOpen: true,
    };
  },
  mounted() {
  },
  methods: {
    closeMessage() {
      this.messageOpen = false;
      this.$store.commit('initialMessageOpen', false);
    },
  },
  props: {
    iniTitle: String,
    iniDescr: String,
    iniLink: String,
  },
};
</script>

<style scoped lang="scss">
.box {
  height: 60px;
  width: 60px;
  background: red;
}
  .initialMessage {
    position: absolute;
    display: none;
    z-index: 10;
    background: rgba(255, 255, 255, 0.5);
    width: 100%;
    height: 100%;

    &.active {
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
    }
  }
  .initialMessageInner {
    font-family: "Austin News Deck Semibold";
    margin: 10px 0;
    font-size: 20px;
    background: #fff;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: flex-start;
    text-align: left;
    width: 100%;
    max-width: 600px;
    height: 100%;
    max-height: 400px;
    margin: 0;
    padding: 30px 40px;
    position: relative;

    @media only screen and (max-width: 767px) {
      width: 80%;
      padding: 20px;
    }

    .iniLogo {
      display: block;
      width: 100%; max-width: 60px; height: auto;

      img {
        display: block;
        width: 100%;
        position: relative;
      }
    }

    .iniTitle {
      font: normal 36px/43px 'LyonBold';
      margin: 20px 0;
    }
    .iniDescr {
      font: normal 13px/18px 'Roboto';
      max-width: 430px;
      width: 100%;
      background: #ffffff75;
      z-index: 6;
    }

    .closeMessage {
      cursor: pointer;
      width: 125px;
      height: 42px;
      margin-top: 20px;
      font: normal 12px/42px 'Roboto';
      text-decoration: none;
      letter-spacing: 0px;
      color: #fff;
      background: #008844 0% 0% no-repeat padding-box;
      border-radius: 2px;
      display: block;
      text-align: center;
      z-index: 5;

      &:hover {
        text-decoration: underline;
      }
    }

    .initIllustration {
      display: block;
      width: 100%;
      background: #ff00004d;
      background: url(~@/assets/extras/l_g_drawing.svg) center 21px no-repeat transparent;
      height: 0;
      padding-bottom: 35%;
      position: absolute;
      left: 0;
      bottom: 0;
      max-height: 240px;
      z-index: 3;
      overflow: hidden;

      .initIllustrationInner {
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
        padding-bottom: 35%;
        overflow: hidden;
      }

      .helixPole {
        width: 137px;
        bottom: -15px;
        height: 190px;

        @media only screen and (max-width: 767px) {
          width: 92px;
          height: 110px;
        bottom: 0;
        }
      }
      .helixPole1 {
        display: block;
        position: absolute;
        left: 50%;
      }

      .helixPole2 {
        display: block;
        position: absolute;
        width: 137px;
        bottom: -15px;
        height: 190px;
        left: 60%;

        @media only screen and (max-width: 767px) {
          width: 100px;
          height: 110px;
          bottom: 2px;
          left: 59%;
        }
      }

      .helixPole3 {
        display: block;
        position: absolute;
        left: 78%;
      }
      .helix1, .helix2, .helix3 {display: block; position: absolute; z-index: 3;
      animation: rotation 17s infinite linear;
      }
      .helix1 {top: 0px; left: -44%; width: 100%; animation-duration: 17s;
        @media only screen and (max-width: 767px) {top: -5px;}
      }
      .helix2 {top: -20.6%; left: -32%; width: 120%; animation-duration: 7s;
        @media only screen and (max-width: 767px) {top: -34px;}
      }
      .helix3 {top: 0px; left: -44%; width: 100%; animation-duration: 17s;
        @media only screen and (max-width: 767px) {top: -5px;}
      }

      .pole1, .pole2, .pole3 {display: block; position: absolute; z-index: 2; }
      .pole1 {top: 30%; left: -2%; width: 16%;}
      .pole2 {top: 17%; left: 20%; width: 15%;}
      .pole3 {top: 30%; left: -2%; width: 16%;}
      .pole {
        transform: scale(0.5) translate(0px, -108px);
        &.pole2 {transform: scale(0.5) translate(0px, -99px);}
      }
      @media only screen and (max-width: 767px) {
        .pole {
          transform: scale(0.5) translate(0px, -70px);
          &.pole2 {transform: scale(0.5) translate(0px, -75px);}
        }
      }

      .cloud1, .cloud2, .cloud3, .cloud4, .cloud1-2, .cloud2-2, .cloud3-2, .cloud4-2 {
        display: block;
        position: absolute;
        width: 8%;
        top: 29%;
        left: 45%;
        z-index: 2;
        animation: moveclouds 35s linear infinite;
      }
      .cloud1-2, .cloud2-2, .cloud3-2, .cloud4-2 {opacity:0.5;}
      .cloud2, .cloud2-2
        {width: 8%; top: 15%; left: 65%; animation: moveclouds 37s linear infinite;}
      .cloud3, .cloud3-2
        {width: 7%; top: 33%; left: 81%; animation: moveclouds 39s linear infinite;}
      .cloud4, .cloud4-2
        {width: 6%; top: 41%; left: 74%; animation: moveclouds 41s linear infinite;}
      .cloud1-2 {left: 145%; animation: moveclouds2 110s linear infinite;}
      .cloud2-2 {left: 165%; animation: moveclouds2 112s linear infinite;}
      .cloud3-2 {left: 181%; animation: moveclouds2 114s linear infinite;}
      .cloud4-2 {left: 174%; animation: moveclouds2 116s linear infinite;}
    }
  }
@keyframes rotation {
  from {transform: rotate(0deg);}
  to {transform: rotate(359deg);}
}

@keyframes moveclouds {
  0% {margin-left: 650px;}
  100% {margin-left: -650px;}
}
@keyframes moveclouds2 {
  0% {margin-left: 1600px;}
  100% {margin-left: -1600px;}
}
</style>
